export enum EApplicationLogLevel {
  All,
  Debug,
  Info,
  Warn,
  Error,
  Off,
}

export enum EElasticLogLevel {
  Error,
  Warn,
  Info,
  Debug,
}

export interface IElasticLog {
  Application: string;
  Collector: string;
  Level: EElasticLogLevel;
  Message: string;
}

export class ElasticLogModel implements IElasticLog {
  Application: string = 'LeaseHawk Portal';

  Message: string;
  Collector: string;
  Level: EElasticLogLevel;

  constructor(message: unknown, level: EElasticLogLevel, collector: string) {
    this.Message = JSON.stringify(message);
    this.Level = level;
    this.Collector = collector.length > 0 ? collector : 'Log Service';
  }
}
